import styled from '@emotion/styled'
import { Chip as MuiChip } from '@mui/material'
import { green, yellow } from '@mui/material/colors'
import { spacing, SpacingProps } from '@mui/system'

import { Colors } from '../Colors'

export interface ChipProps extends SpacingProps {
  status: 'note' | 'done' | 'red' | 'grey' | 'green' | 'yellow' | 'info'
}

export const TaskChip = styled(MuiChip)<ChipProps>`
  ${spacing};
  background: ${props => {
    switch (props.status) {
      case 'done':
      case 'green':
        return green[700]
      case 'note':
      case 'yellow':
        return yellow[700]
      case 'red':
        return Colors.RED
      case 'grey':
        return Colors.GRAY_600
      case 'info':
        return props.theme.palette.info.main
    }
  }};
  color: ${props => props.theme.palette.common.white};
`
